import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { validateLeadTimeNotes } from '../validations/lead-time-notes';
import { QuoteLineParams } from './types';

interface Params extends QuoteLineParams {
  leadTimeNotes: string;
}

export function leadTimeNotesChanged(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<Params>,
) {
  const { quoteLineUuid, leadTimeNotes } = action.payload;
  const newLeadTimeNotes = validateLeadTimeNotes(state, {
    leadTimeNotes,
    quoteLineUuid,
  });

  const quoteLine = getQuoteLineOrThrow(state, quoteLineUuid);

  quoteLine.leadTimeNotes = newLeadTimeNotes;
}
